// Les sons d'un événement de puzzles. `pick` : la pièce sortie du coffre ; `land` : la pièce
// qui s'enclenche ; `done` : le puzzle fini. Les fichiers commencent sans silence : le son part
// à l'instant voulu. Un événement peut donner les siens dans son bloc (theme.sounds) ; ceux
// qu'il ne donne pas restent ceux-ci.
// Il peut aussi habiller le coffre : `appear`, `taps` (un son par tape), `upgrade`, `open`,
// `reveal`, `recap`. Ceux-là n'ont pas de défaut ici : sans eux, le coffre garde ses sons.
const DEFAULTS = {
    pick: "/static/sounds/pick-piece-puzzles.mp3",
    land: "/static/sounds/put-piece-puzzles.mp3",
    done: "/static/sounds/completed-puzzles.mp3",
};

export const eventSounds = (event) => ({ ...DEFAULTS, ...(event?.theme?.sounds || {}) });

// Les sons du coffre que l'événement remplace, à plat, pour les télécharger d'avance.
export const chestSoundFiles = (sounds) =>
    [sounds?.appear, ...(sounds?.taps || []), sounds?.upgrade, sounds?.open, sounds?.reveal, sounds?.recap].filter(Boolean);
